import { connect } from 'react-redux';

import { getUsersReadPermissions, getUsersUpdatePermissions } from 'modules/session/selectors/permissions';
import { getUserFullNameWithMiddleName } from 'modules/user/utils/user';
import { invokeEditUserModal } from '../../actions/invokeModals';
import { getCommonUserConfig } from '../../selectors/users';

import UserDetailsDetails from './UserDetailsDetails';

const mapStateToProps = state => {
  const { policyId, firstName, lastName, middleName, title, gender, email, phoneNumber, address, dateOfBirth, description } = state.auth.userInfo.profile;
  const userReadPermissions = getUsersReadPermissions(state);
  const userUpdatePermissions = getUsersUpdatePermissions(state);

  return {
    title,
    fullName: getUserFullNameWithMiddleName({ firstName, lastName, middleName }),
    gender,
    email,
    phoneNumber,
    policyId,
    address,
    description,
    dateOfBirth: dateOfBirth ? Number(dateOfBirth) : null,
    userReadPermissions,
    userUpdatePermissions,
    userFieldConfig: getCommonUserConfig(state),
  };
};

export default connect(
  mapStateToProps,
  { invokeEditUserModal },
)(UserDetailsDetails);
